<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

/**
 * Inscripción documento
 */
export default {
  components: { Layout, PageHeader, },
  page: {
    title: 'Inscripción',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {     
      title: 'Inscripción',
     
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Documentos',
          href: '/documentos/add',
        },
        {
          text: 'Inscripción',
          active: true,
        },
      ]
    }
  }
  ,
  computed:{
  
  },
  mounted(){
  

         
  },
   methods:{
   
}
    
}
</script>
<template>
  <Layout>
       <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-6">
                 <div class="card-box">
                     <h4 class="header-title m-t-0"> <i class="fas fa-check-circle"></i> Se ha guardado la información del Documento</h4>
                       <router-link class="btn btn-secondary m-l-5 ml-1" to="/documentos/add"> Agregar Documento</router-link>
                 </div>
            </div>
        </div>
  </Layout>
</template>